export default __webpack_public_path__ + "static/media/dj.9d6f9c1f.svg";